import React from 'react';
import styled, { keyframes } from 'styled-components';
import { zIndex } from '../../global/globals';
import media from '../../base/media';

const entry = keyframes`
	0% { opacity: 0; transform: translate3d(0, -80%, 0); }
	20% { opacity: 0.5; }
	100% { opacity: 1; transform: translate3d(0, -5px, 0); }
`;

const dangle = keyframes`
	0% { transform: translate3d(0, -5px, 0); }
	50% { transform: translate3d(0, 0, 0); }
	100% { transform: translate3d(0, -5px, 0); }
`;

const LightsInner = styled.div`
	position: relative;
`;

const StyledLights = styled.div`
	display: none;
	position: absolute;
	top: 0;
	left: 35%;
	z-index: ${zIndex.lights};
	opacity: 0;
	animation: ${entry} 700ms ease 500ms, ${dangle} 2s cubic-bezier(0.49, 0.31, 0.49, 0.98) infinite 1150ms;
	animation-fill-mode: forwards;

	#Hanging-Lamp, #Wire {
		transition: fill ${props => props.theme.theming.nightDayTransitionDuration} ease;
		fill: ${props => props.theme.hero.lightsFill};
	}

	#Hanging-Lamp-Light {
		transition: fill ${props => props.theme.theming.nightDayTransitionDuration} ease;
		fill: ${props => props.theme.hero.lightsLightFill};
	}

	${media.desktopSmall`
		display: block;
	`}
`;

const StyledLightsGlow = styled.img`
	position: absolute;
	bottom: -13%;
	left: -5%;
	z-index: -1;
	opacity: ${({ theme }) => theme.theming.nightThemeGradientOpacity};
	transition: opacity ${({ theme }) => theme.theming.nightDayTransitionDuration};
`;

const StyledLightsGlowSmaller = styled(StyledLightsGlow)`
	bottom: 10%;
	left: 52%;
	width: 50%;
`;

const Lights = () => (
	<StyledLights>
		<LightsInner>
			<StyledLightsGlow src="./assets/images/ljos-vinstra.png" alt="Ljós vinstra" />
			<StyledLightsGlowSmaller src="./assets/images/ljos-vinstra.png" alt="Ljós vinstra" />
			<svg width="164px" height="207px" viewBox="0 0 164 207" version="1.1">
				<title>Group 9</title>
				<desc>Created with Sketch.</desc>
				<g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
					<g id="Bríet" transform="translate(-673.000000, 0.000000)">
						<g id="Group-9" transform="translate(673.000000, -3.000000)">
							<ellipse id="Hanging-Lamp-Light" fill="#F2F2F2" cx="49.5" cy="187.5" rx="42.5" ry="22.5"></ellipse>
							<path d="M99,203 C99,175.385763 76.8380951,153 49.5,153 C22.1619049,153 0,175.385763 0,203" id="Hanging-Lamp" fill="#DDE3E9"></path>
							<rect id="Wire" fill="#DDE3E9" x="47" y="0" width="5" height="160"></rect>
							<ellipse id="Hanging-Lamp-Light" fill="#F2F2F2" cx="127" cy="141" rx="32" ry="18"></ellipse>
							<path d="M164,153 C164,130.90861 147.434536,113 127,113 C106.565464,113 90,130.90861 90,153" id="Hanging-Lamp" fill="#DDE3E9"></path>
							<rect id="Wire" fill="#DDE3E9" x="125" y="0" width="5" height="136"></rect>
						</g>
					</g>
				</g>
			</svg>
		</LightsInner>
	</StyledLights>
);

export default Lights;
